import React from "react";

const SvgLargeCan = props => (
  <svg viewBox="0 0 215 190" {...props}>
    <path
      d="M132 18.5h.3c1 0 2-.9 2-2s-.9-2-2-2H82.7c-1 0-2 .9-2 2s.9 2 2 2h.3L76.6 28v138.4l5.1 10.6h51.6l5.1-10.6V28.2l-6.4-9.7zm-44.3 0h39.5l3.8 5.6H84l3.7-5.6zm40.8 31v95.8h-42V49.5h42zm2.3 123.7H84.2l-1.3-2.7h49.3l-1.4 2.7z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLargeCan;